import type { CourseModule } from "@/core/types";
import { lektionKommentare } from "./lektion-01-kommentare";
import { lektionNachverfolgen } from "./lektion-02-nachverfolgen";
import { lektionAnnehmen } from "./lektion-03-annehmen";
import { lektionVergleichen } from "./lektion-04-vergleichen";
import { lektionVorDemVersand } from "./lektion-05-vor-dem-versand";
import { lektionZusammenarbeitAbschluss } from "./lektion-06-abschluss";

export const modulZusammenarbeit: CourseModule = {
  id: "zusammenarbeit",
  title: "Zusammenarbeit: Kommentare und Änderungen",
  summary:
    "Dokumente gemeinsam überarbeiten – kommentieren, Änderungen nachverfolgen, " +
    "entscheiden und vor der Weitergabe sauber aufräumen.",
  level: "Grundlagen",
  lessons: [
    lektionKommentare,
    lektionNachverfolgen,
    lektionAnnehmen,
    lektionVergleichen,
    lektionVorDemVersand,
    lektionZusammenarbeitAbschluss,
  ],
};
